import { render, staticRenderFns } from "./BaseInput.vue?vue&type=template&id=982212c8&scoped=true"
import script from "./BaseInput.vue?vue&type=script&lang=js"
export * from "./BaseInput.vue?vue&type=script&lang=js"
import style0 from "./BaseInput.vue?vue&type=style&index=0&id=982212c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "982212c8",
  null
  
)

export default component.exports